import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "18",
      cy: "18",
      r: "17",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.8672 20.1016C18.0898 19.8789 18.0898 19.4707 17.8672 19.248L16.9395 18.3203C16.7168 18.0977 16.3086 18.0977 16.0859 18.3203L12.6719 21.7344L11.4844 20.5469C10.9277 19.9531 10 20.3613 10 21.1406V25.2969C10 25.8164 10.3711 26.1875 10.8535 26.1875H15.0098C15.8262 26.1875 16.2344 25.2598 15.6406 24.7031L14.4531 23.5156L17.8672 20.1016ZM18.7207 15.6855C18.498 15.9082 18.498 16.3164 18.7207 16.5391L19.6484 17.4668C19.8711 17.6895 20.2793 17.6895 20.502 17.4668L23.9531 14.0156L25.1035 15.2402C25.6602 15.834 26.625 15.4258 26.625 14.6094V10.4531C26.625 9.9707 26.2168 9.5625 25.7344 9.5625H21.5781C20.7617 9.5625 20.3535 10.5273 20.9473 11.084L22.1719 12.2344L18.7207 15.6855Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }